import { useCallback } from 'react';

import type { AnyObject } from '../../../../../types';
import { bridge } from '../../../../../utils';
import { useAtomicScreen } from '../../../context/AtomicScreenContext';

export const useLogClickBanner = (logging: AnyObject) => {
  const screen = useAtomicScreen();

  const logClickBannerAll = useCallback(() => {
    bridge.logAnalyticsEvent({
      name: 'CLICK_BANNER',
      analytics: {
        ...logging.analytics,
        ...(screen != null && { SCREEN: screen }),
      },
      ably_only_log: logging.ably_only_log as AnyObject,
    });
  }, [logging, screen]);

  const logClickBannerItem = useCallback(
    (itemLogging: AnyObject) => {
      bridge.logAnalyticsEvent({
        name: 'CLICK_BANNER',
        analytics: {
          ...logging.analytics,
          ...itemLogging.analytics,
          ...(screen != null && { SCREEN: screen }),
        },
        ably_only_log: {
          ...(logging.ably_only_log as AnyObject),
          ...(itemLogging.ably_only_log as AnyObject),
        },
      });
    },
    [logging, screen],
  );

  return { logClickBannerAll, logClickBannerItem };
};
